import axios from './apiClient';

const apiUrl = process.env.REACT_APP_API_URL;
const API_URL = `${apiUrl}`;
function convertDateFormat(dateString) {
  const mnths = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    May: "05",
    Jun: "06",
    Jul: "07",
    Aug: "08",
    Sep: "09",
    Oct: "10",
    Nov: "11",
    Dec: "12"
  };

  const dateArray = dateString.split(" ");
  const year = dateArray[3];
  const month = mnths[dateArray[1]];
  const day = dateArray[2];

  return `${year}-${month}-${day}`;
}
const fetchCompanyInvoices = async (page, pageSize, selectedType, userEmail, startDate, endDate) => {
  //console.log('pagesize ',pageSize )
 
  let payFromDateInput;
  let payToDateInput;
  if(startDate && endDate){
    payFromDateInput = convertDateFormat(startDate.toString());
    payToDateInput = convertDateFormat(endDate.toString());
  }
 
  // console.log('selectedType ',selectedType)
  // console.log('pageSize ',pageSize)
  // console.log('page ',page)
  // console.log('startDate ',startDate)
  // console.log('endDate ',endDate)
  const response = await axios.post(`${API_URL}/getCompanyInvoice`, {
    page: page,
    pageSize: pageSize,
    type: selectedType, 
    email: userEmail, 
    payFromDate: payFromDateInput, 
    payToDate: payToDateInput
  });
  //console.log('response.data ',response.data.error)
  return response.data.data;
};

const fetchInvoiceCount = async (selectedType, userEmail, startDate, endDate) => {
  let payFromDateInput;
  let payToDateInput;
  if(startDate && endDate){
    payFromDateInput = convertDateFormat(startDate.toString());
    payToDateInput = convertDateFormat(endDate.toString());
  }
  const response = await axios.post(`${API_URL}/companyInvoiceListCount`, {
    type: selectedType, 
    email: userEmail, 
    payFromDate: payFromDateInput, 
    payToDate: payToDateInput
  });
  //console.log('count is :- ', response.data.data)
  return response.data.data;
};

export { fetchCompanyInvoices, fetchInvoiceCount };
